import { render, staticRenderFns } from "./ListedQuestion.vue?vue&type=template&id=d90ff15a&scoped=true&"
import script from "./ListedQuestion.vue?vue&type=script&lang=ts&"
export * from "./ListedQuestion.vue?vue&type=script&lang=ts&"
import style0 from "./ListedQuestion.vue?vue&type=style&index=0&id=d90ff15a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d90ff15a",
  null
  
)

export default component.exports